unit InvoiceEditPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  EditBaseForm,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  WEBLib.WebCtrls,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.DBCtrls,
  WEBLib.Grids;

type
  TInvoiceEditForm = class(TBaseEditForm)
    DueDateEdit: TDBDateTimePicker;
    GrossAmountEdit: TDBEdit;
    InvoiceDateEdit: TDBDateTimePicker;
    InvoiceTypeEdit: TDBComboBox;
    SchoolDataSource: TDataSource;
    SchoolEdit: TDBLookupComboBox;
    InvoiceRefEdit: TDBEdit;
    DetailTable: TDBTableControl;
    AddDetailButton: TButton;
    ChildDataSource: TDataSource;
    chkPaidInFull: TDBCheckBox;
    procedure DetailTableGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure DetailTableGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure AddDetailButtonClick(Sender: TObject);
    procedure SaveButtonClick(Sender: TObject);
  private
    { Private declarations }
    FItemUpdated: Boolean;

    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
    procedure DeleteRecord(const ARecordId: string);
    function GetFieldNameByColIndex(ACol: Integer): string;

    procedure OnCellBlurEvent(Event: TJSEvent);
    procedure OnCellInputEvent(Event: TJSEvent);

  protected
    function GetRequiredEditLevel: string; override;

    procedure AfterSetDataset; override;

    function CanSaveThis: Boolean; override;

  public
    { Public declarations }
    [async]
    procedure InitForm; async; override;

  protected procedure LoadDFMValues; override; end;

var
  InvoiceEditForm: TInvoiceEditForm;

implementation

{$R *.dfm}

uses
  InvoiceListPage,
  Rtti,
  MainDataModule,
  CRM.Enumerations,
  App.Shared,
  App.Web.Utils,
  Web.StringUtils,
  SMX.Web.Layout.Utils;

procedure TInvoiceEditForm.InitForm;
var
  oInvoiceKind: TInvoiceKind;

begin
  inherited;

  for oInvoiceKind := Low(TInvoiceKind) to High(TInvoiceKind) do
    InvoiceTypeEdit.Items.Add(TRttiEnumerationType.GetName<TInvoiceKind>(oInvoiceKind));

  SchoolDataSource.DataSet := MainData.SchoolLookUp;

end;

procedure TInvoiceEditForm.AddDetailButtonClick(Sender: TObject);
var
  iId: Integer;

begin
  inherited;

  // Store the current id
  iId := DataSource.DataSet.FieldByName('Id').AsInteger;

  // Add the new record
  MainData.InvoiceDetailDataSet.DisableControls;
  MainData.InvoiceDetailDataSet.Append;
  MainData.InvoiceDetailDataSet.FieldByName('InvoiceId').AsInteger := iId;
  MainData.InvoiceDetailDataSet.Post;
  MainData.InvoiceDetailDataSet.ApplyUpdates;
  MainData.InvoiceDetailDataSet.EnableControls;

  FItemUpdated := True;

end;

procedure TInvoiceEditForm.DetailTableGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
begin
  inherited;

  if ARow = 0 then
    Exit;

  if DetailTable.Columns[ACol].Title = 'Actions' then
    AddRowActions(MainData.InvoiceDetailDataSet.FieldByName(FIdField).AsString, AElement.Element)
  else if (ARow > 0) and (ACol >= 0) and (ACol < DetailTable.Columns.Count - 1) then
  begin
    // Make cells editable
    AElement.element.setAttribute('contenteditable', 'true');
    AElement.element.setAttribute('class', AElement.element.getAttribute('class') + ' editable-cell');

    // Store the data in the cell for use later
    AElement.element.setAttribute('data-col-index', IntToStr(ACol));
    AElement.element.setAttribute('data-field-name', GetFieldNameByColIndex(ACol));
    AElement.element.setAttribute('data-record-id', MainData.InvoiceDetailDataSet.FieldByName(FIdField).AsString);

    // Add events to handle input sanitization
    AElement.element.addEventListener('blur', @OnCellBlurEvent);
    if DetailTable.Columns[ACol].Title <> 'Description' then
      AElement.element.addEventListener('input', @OnCellInputEvent);

  end
  else if ACol = 0 then
    AElement.Element.style.setProperty('display', 'none');

end;

procedure TInvoiceEditForm.DetailTableGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  inherited;

  if Assigned(AField) then
    if (AField.FieldName = 'Rate') or (AField.FieldName = 'TotalValue') then
      AValue := Format('%.2n', [StrToFloatDef(AValue,0)]);

end;

function TInvoiceEditForm.GetRequiredEditLevel: string;
begin
  Result := GetStandardEditLevel;

end;

procedure TInvoiceEditForm.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
var
  DeleteSpan: THTMLSpan;

  procedure DeleteItemClick(Sender: TObject);
  begin
    DeleteRecord(ARecordId);

  end;

begin
  inherited;

  DeleteSpan := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-trash fa-fw fa-lg', 'Delete');
  DeleteSpan.OnClick := @DeleteItemClick;

end;

procedure TInvoiceEditForm.DeleteRecord(const ARecordId: string);
begin
  if MainData.InvoiceDetailDataSet.Locate('Id', ARecordId, []) then
  begin
    MainData.InvoiceDetailDataSet.Delete;
    MainData.InvoiceDetailDataSet.ApplyUpdates;

    FItemUpdated := True;

  end;

end;

function TInvoiceEditForm.GetFieldNameByColIndex(ACol: Integer): string;
begin
  // Map column index to field name
  if ACol < DetailTable.Columns.Count then
    Result := DetailTable.Columns[ACol].DataField
  else
    Result := '';

end;

procedure TInvoiceEditForm.OnCellBlurEvent(Event: TJSEvent);
var
  Element: TJSHTMLElement;
  RecordId, NewValue: string;
  ColIndex: Integer;
  FieldName: string;

begin
  Element := TJSHTMLElement(Event.target);
  RecordId := Element.getAttribute('data-record-id');
  ColIndex := StrToIntDef(Element.getAttribute('data-col-index'), -1);

  if (RecordId <> '') and (ColIndex >= 0) then
  begin
    NewValue := StringReplace(Element.innerText, '', '', [rfReplaceAll]);
    FieldName := GetFieldNameByColIndex(ColIndex);

    if (FieldName <> '') and MainData.InvoiceDetailDataSet.Locate('Id', RecordId, []) then
    begin
      MainData.InvoiceDetailDataSet.Edit;

      // Handle different field types appropriately
      if MainData.InvoiceDetailDataSet.FieldByName(FieldName) is TIntegerField then
        MainData.InvoiceDetailDataSet.FieldByName(FieldName).AsInteger := StrToIntDef(NewValue, 0)
      else if MainData.InvoiceDetailDataSet.FieldByName(FieldName) is TNumericField then
        MainData.InvoiceDetailDataSet.FieldByName(FieldName).AsFloat := StrToFloatDef(NewValue, 0)
      else
        MainData.InvoiceDetailDataSet.FieldByName(FieldName).AsString := NewValue;

      MainData.InvoiceDetailDataSet.Post;
      MainData.InvoiceDetailDataSet.ApplyUpdates;

      FItemUpdated := True;

    end;

  end;

//  TXDataWebDataSet(ChildDataSource.DataSet).QueryString := '$orderby=PupilMin desc';

end;

procedure TInvoiceEditForm.SaveButtonClick(Sender: TObject);
begin
  inherited;

  if FItemUpdated then
    MainData.InvoiceDetailDataSet.ApplyUpdates;

end;

procedure TInvoiceEditForm.AfterSetDataset;
var
  bEditing: Boolean;

begin
  inherited;

  // editing?
  bEditing := DataSource.DataSet.FieldByName('Id').AsInteger <> 0;

  // only show add button if editing
  AddDetailButton.Visible := bEditing;

  // disable components that shouldn't be editable
  InvoiceDateEdit.ReadOnly := bEditing;
  InvoiceTypeEdit.Enabled := not bEditing;
  InvoiceRefEdit.ReadOnly := bEditing;
  SchoolEdit.Enabled := not bEditing;

end;

function TInvoiceEditForm.CanSaveThis: Boolean;
begin
  Result := inherited;

  Result := Result or MainData.InvoiceDetailDataSet.Modified or FItemUpdated;

  if Result then
    DataSource.DataSet.Edit;

end;

procedure TInvoiceEditForm.OnCellInputEvent(Event: TJSEvent);
var
  oElement: TJSHTMLElement;
  sSource: string;
  sTarget: string;

begin
  oElement := TJSHTMLElement(Event.target);
  sSource := oElement.innerText;

  sTarget := SanitizeNumericCellInput(sSource);

  if sTarget <> sSource then
    oElement.innerText := sTarget;

end;

procedure TInvoiceEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  DueDateEdit := TDBDateTimePicker.Create('invoice-due-date-edit');
  GrossAmountEdit := TDBEdit.Create('invoice-gross-amount-edit');
  InvoiceDateEdit := TDBDateTimePicker.Create('invoice-date-edit');
  InvoiceTypeEdit := TDBComboBox.Create('invoice-type-edit');
  SchoolEdit := TDBLookupComboBox.Create('school-edit');
  InvoiceRefEdit := TDBEdit.Create('invoice-ref-edit');
  DetailTable := TDBTableControl.Create('child-data-table');
  AddDetailButton := TButton.Create('add-item');
  chkPaidInFull := TDBCheckBox.Create('paid-in-full');
  SchoolDataSource := TDataSource.Create(Self);
  ChildDataSource := TDataSource.Create(Self);

  DueDateEdit.BeforeLoadDFMValues;
  GrossAmountEdit.BeforeLoadDFMValues;
  InvoiceDateEdit.BeforeLoadDFMValues;
  InvoiceTypeEdit.BeforeLoadDFMValues;
  SchoolEdit.BeforeLoadDFMValues;
  InvoiceRefEdit.BeforeLoadDFMValues;
  DetailTable.BeforeLoadDFMValues;
  AddDetailButton.BeforeLoadDFMValues;
  chkPaidInFull.BeforeLoadDFMValues;
  SchoolDataSource.BeforeLoadDFMValues;
  ChildDataSource.BeforeLoadDFMValues;
  try
    Name := 'InvoiceEditForm';
    Caption := 'school-edit';
    DueDateEdit.SetParentComponent(Self);
    DueDateEdit.Name := 'DueDateEdit';
    DueDateEdit.Left := 54;
    DueDateEdit.Top := 220;
    DueDateEdit.Width := 248;
    DueDateEdit.Height := 22;
    DueDateEdit.ElementClassName := 'form-control';
    DueDateEdit.HeightStyle := ssAuto;
    DueDateEdit.WidthStyle := ssAuto;
    DueDateEdit.BorderStyle := bsSingle;
    DueDateEdit.ChildOrder := 10;
    DueDateEdit.Color := clWhite;
    DueDateEdit.Date := 45757.597146226850000000;
    DueDateEdit.ElementFont := efCSS;
    DueDateEdit.ElementPosition := epIgnore;
    DueDateEdit.Role := '';
    DueDateEdit.TabOrder := 4;
    DueDateEdit.Text := '';
    DueDateEdit.DataField := 'DueDate';
    DueDateEdit.DataSource := DataSource;
    GrossAmountEdit.SetParentComponent(Self);
    GrossAmountEdit.Name := 'GrossAmountEdit';
    GrossAmountEdit.Left := 308;
    GrossAmountEdit.Top := 220;
    GrossAmountEdit.Width := 248;
    GrossAmountEdit.Height := 22;
    GrossAmountEdit.ChildOrder := 10;
    GrossAmountEdit.EditType := weFloat;
    GrossAmountEdit.ElementClassName := 'form-control';
    GrossAmountEdit.ElementFont := efCSS;
    GrossAmountEdit.ElementPosition := epIgnore;
    GrossAmountEdit.HeightStyle := ssAuto;
    GrossAmountEdit.HeightPercent := 100.000000000000000000;
    GrossAmountEdit.TabOrder := 5;
    GrossAmountEdit.Text := 'GrossAmountEdit';
    GrossAmountEdit.WidthStyle := ssAuto;
    GrossAmountEdit.WidthPercent := 100.000000000000000000;
    GrossAmountEdit.DataField := 'GrossAmount';
    GrossAmountEdit.DataSource := DataSource;
    InvoiceDateEdit.SetParentComponent(Self);
    InvoiceDateEdit.Name := 'InvoiceDateEdit';
    InvoiceDateEdit.Left := 54;
    InvoiceDateEdit.Top := 164;
    InvoiceDateEdit.Width := 145;
    InvoiceDateEdit.Height := 22;
    InvoiceDateEdit.ElementClassName := 'form-control';
    InvoiceDateEdit.HeightStyle := ssAuto;
    InvoiceDateEdit.WidthStyle := ssAuto;
    InvoiceDateEdit.BorderStyle := bsSingle;
    InvoiceDateEdit.ChildOrder := 10;
    InvoiceDateEdit.Color := clWhite;
    InvoiceDateEdit.Date := 45757.597146226850000000;
    InvoiceDateEdit.ElementFont := efCSS;
    InvoiceDateEdit.ElementPosition := epIgnore;
    InvoiceDateEdit.Role := '';
    InvoiceDateEdit.Text := '';
    InvoiceDateEdit.DataField := 'InvoiceDate';
    InvoiceDateEdit.DataSource := DataSource;
    InvoiceTypeEdit.SetParentComponent(Self);
    InvoiceTypeEdit.Name := 'InvoiceTypeEdit';
    InvoiceTypeEdit.Left := 235;
    InvoiceTypeEdit.Top := 163;
    InvoiceTypeEdit.Width := 145;
    InvoiceTypeEdit.Height := 23;
    InvoiceTypeEdit.ElementClassName := 'form-select form-control';
    InvoiceTypeEdit.ElementFont := efCSS;
    InvoiceTypeEdit.HeightStyle := ssAuto;
    InvoiceTypeEdit.HeightPercent := 100.000000000000000000;
    InvoiceTypeEdit.TabOrder := 1;
    InvoiceTypeEdit.Text := 'InvoiceTypeEdit';
    InvoiceTypeEdit.WidthPercent := 100.000000000000000000;
    InvoiceTypeEdit.ItemIndex := -1;
    InvoiceTypeEdit.DataField := 'InvoiceType';
    InvoiceTypeEdit.DataSource := DataSource;
    SchoolEdit.SetParentComponent(Self);
    SchoolEdit.Name := 'SchoolEdit';
    SchoolEdit.Left := 54;
    SchoolEdit.Top := 192;
    SchoolEdit.Width := 502;
    SchoolEdit.Height := 22;
    SchoolEdit.ElementClassName := 'form-select form-control';
    SchoolEdit.ElementFont := efCSS;
    SchoolEdit.ElementPosition := epIgnore;
    SchoolEdit.HeightStyle := ssAuto;
    SchoolEdit.HeightPercent := 100.000000000000000000;
    SchoolEdit.TabOrder := 3;
    SchoolEdit.WidthStyle := ssAuto;
    SchoolEdit.WidthPercent := 100.000000000000000000;
    SchoolEdit.DataField := 'ParentId';
    SchoolEdit.DataSource := DataSource;
    SchoolEdit.KeyField := 'Id';
    SchoolEdit.ListField := 'LocationName';
    SchoolEdit.ListSource := SchoolDataSource;
    InvoiceRefEdit.SetParentComponent(Self);
    InvoiceRefEdit.Name := 'InvoiceRefEdit';
    InvoiceRefEdit.Left := 411;
    InvoiceRefEdit.Top := 164;
    InvoiceRefEdit.Width := 145;
    InvoiceRefEdit.Height := 22;
    InvoiceRefEdit.ChildOrder := 18;
    InvoiceRefEdit.ElementClassName := 'form-control';
    InvoiceRefEdit.ElementFont := efCSS;
    InvoiceRefEdit.ElementPosition := epIgnore;
    InvoiceRefEdit.HeightStyle := ssAuto;
    InvoiceRefEdit.HeightPercent := 100.000000000000000000;
    InvoiceRefEdit.MaxLength := 50;
    InvoiceRefEdit.TabOrder := 2;
    InvoiceRefEdit.Text := 'InvoiceRefEdit';
    InvoiceRefEdit.WidthStyle := ssAuto;
    InvoiceRefEdit.WidthPercent := 100.000000000000000000;
    InvoiceRefEdit.DataField := 'InvoiceRef';
    InvoiceRefEdit.DataSource := DataSource;
    DetailTable.SetParentComponent(Self);
    DetailTable.Name := 'DetailTable';
    DetailTable.Left := 623;
    DetailTable.Top := 172;
    DetailTable.Width := 242;
    DetailTable.Height := 98;
    DetailTable.HeightStyle := ssAuto;
    DetailTable.WidthStyle := ssPercent;
    DetailTable.BorderColor := clSilver;
    DetailTable.ChildOrder := 21;
    DetailTable.ElementFont := efCSS;
    DetailTable.ElementHeaderClassName := 'thead-light';
    DetailTable.ElementPosition := epIgnore;
    DetailTable.ElementTableClassName := 'table table-striped table-bordered table-hover';
    DetailTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    DetailTable.Footer.ButtonElementClassName := 'btn btn-light';
    DetailTable.Footer.DropDownElementClassName := 'form-control';
    DetailTable.Footer.InputElementClassName := 'form-control';
    DetailTable.Footer.LinkActiveElementClassName := 'link-primary';
    DetailTable.Footer.LinkElementClassName := 'link-secondary';
    DetailTable.Footer.ListElementClassName := 'pagination';
    DetailTable.Footer.ListItemElementClassName := 'page-item';
    DetailTable.Footer.ListLinkElementClassName := 'page-link';
    DetailTable.Header.FilterColumn := 1;
    DetailTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    DetailTable.Header.ButtonElementClassName := 'btn btn-light';
    DetailTable.Header.DropDownElementClassName := 'form-control';
    DetailTable.Header.InputElementClassName := 'form-control';
    DetailTable.Header.LinkActiveElementClassName := 'link-primary';
    DetailTable.Header.LinkElementClassName := 'link-secondary';
    DetailTable.Header.ListElementClassName := 'pagination';
    DetailTable.Header.ListItemElementClassName := 'page-item';
    DetailTable.Header.ListLinkElementClassName := 'page-link';
    SetEvent(DetailTable, Self, 'OnGetCellData', 'DetailTableGetCellData');
    SetEvent(DetailTable, Self, 'OnGetCellChildren', 'DetailTableGetCellChildren');
    DetailTable.Columns.Clear;
    with DetailTable.Columns.Add do
    begin
      DataField := 'Id';
      Width := 1;
    end;
    with DetailTable.Columns.Add do
    begin
      DataField := 'Description';
      Title := 'Description';
      Width := 200;
    end;
    with DetailTable.Columns.Add do
    begin
      DataField := 'Quantity';
      Title := 'Quantity';
      Width := 100;
    end;
    with DetailTable.Columns.Add do
    begin
      DataField := 'Rate';
      Title := 'Rate';
      Width := 120;
    end;
    with DetailTable.Columns.Add do
    begin
      DataField := 'TotalValue';
      Title := 'Total';
      Width := 100;
    end;
    with DetailTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    DetailTable.DataSource := ChildDataSource;
    AddDetailButton.SetParentComponent(Self);
    AddDetailButton.Name := 'AddDetailButton';
    AddDetailButton.Left := 623;
    AddDetailButton.Top := 276;
    AddDetailButton.Width := 36;
    AddDetailButton.Height := 38;
    AddDetailButton.Caption := 'Add';
    AddDetailButton.ChildOrder := 22;
    AddDetailButton.ElementClassName := 'btn btn-primary';
    AddDetailButton.ElementFont := efCSS;
    AddDetailButton.ElementPosition := epIgnore;
    AddDetailButton.HeightStyle := ssAuto;
    AddDetailButton.HeightPercent := 100.000000000000000000;
    AddDetailButton.WidthStyle := ssAuto;
    AddDetailButton.WidthPercent := 100.000000000000000000;
    SetEvent(AddDetailButton, Self, 'OnClick', 'AddDetailButtonClick');
    chkPaidInFull.SetParentComponent(Self);
    chkPaidInFull.Name := 'chkPaidInFull';
    chkPaidInFull.Left := 443;
    chkPaidInFull.Top := 248;
    chkPaidInFull.Width := 113;
    chkPaidInFull.Height := 22;
    chkPaidInFull.Caption := 'Paid in Full';
    chkPaidInFull.ChildOrder := 17;
    chkPaidInFull.ElementClassName := 'custom-control custom-checkbox';
    chkPaidInFull.ElementButtonClassName := 'custom-control-input';
    chkPaidInFull.ElementLabelClassName := 'custom-control-label';
    chkPaidInFull.ElementFont := efCSS;
    chkPaidInFull.ElementPosition := epIgnore;
    chkPaidInFull.HeightStyle := ssAuto;
    chkPaidInFull.HeightPercent := 100.000000000000000000;
    chkPaidInFull.WidthStyle := ssAuto;
    chkPaidInFull.WidthPercent := 100.000000000000000000;
    chkPaidInFull.DataField := 'PaidInFull';
    chkPaidInFull.DataSource := DataSource;
    SchoolDataSource.SetParentComponent(Self);
    SchoolDataSource.Name := 'SchoolDataSource';
    SchoolDataSource.Left := 536;
    SchoolDataSource.Top := 64;
    ChildDataSource.SetParentComponent(Self);
    ChildDataSource.Name := 'ChildDataSource';
    ChildDataSource.Left := 688;
    ChildDataSource.Top := 64;
  finally
    DueDateEdit.AfterLoadDFMValues;
    GrossAmountEdit.AfterLoadDFMValues;
    InvoiceDateEdit.AfterLoadDFMValues;
    InvoiceTypeEdit.AfterLoadDFMValues;
    SchoolEdit.AfterLoadDFMValues;
    InvoiceRefEdit.AfterLoadDFMValues;
    DetailTable.AfterLoadDFMValues;
    AddDetailButton.AfterLoadDFMValues;
    chkPaidInFull.AfterLoadDFMValues;
    SchoolDataSource.AfterLoadDFMValues;
    ChildDataSource.AfterLoadDFMValues;
  end;
end;

end.